import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import {
  FaBook,
} from "react-icons/fa";

import "./DivisionPageJana.css";


const divisions = [
  {
    title: "Elementary",
    icon: <FaBook />,
    description:
      "Our Elementary division focuses on building a strong foundation in reading, writing, and critical thinking. We nurture curiosity, creativity, and a love for lifelong learning.",
  },
  
{
  title: "Junior High",
  icon: <FaBook />,
  description:
    "Our Junior High division prepares students for the next stage of their academic journey by strengthening knowledge, critical thinking, problem-solving, and personal responsibility. We encourage confidence, creativity, and a passion for lifelong learning.",
  },
];


const DivisionPage = () => {


  useEffect(() => {

    AOS.init({
      duration: 1000,
      once: true,
    });

  }, []);



  return (

    <section className="education-division-section">


      <div className="education-division-header">


        <span className="education-badge">
          Academic Programs
        </span>



        <h2>
          Excellence Across Every
          <span> Learning Division</span>
        </h2>



        <p>
          Our carefully designed academic divisions provide
          students with the knowledge, skills, and confidence
          needed to succeed at every stage of their education.
        </p>


      </div>




      <div className="education-division-container">


        {
          divisions.map((division,index)=>(


            <div
              className="education-division-card"
              key={division.title}
              data-aos="fade-up"
              data-aos-delay={index * 200}
            >


              <div className="education-icon-box">

                {division.icon}

              </div>




              <h3>
                {division.title}
              </h3>




              <p>
                {division.description}
              </p>




              <div className="education-card-line"></div>



            </div>


          ))
        }


      </div>



    </section>

  );

};


export default DivisionPage;

